"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _contentType = require("@insided/shared/utils/contentType");

var _VotedUsers = _interopRequireDefault(require("../../../VotedUsers"));

var _TopicVoteCount = require("@insided/destination/uikit/TopicVoteCount");

var _OnDemandTranslations = require("@insided/shared/modules/HubAI/OnDemandTranslations");

var _TopicHeaderMetaInfo = _interopRequireDefault(require("./TopicHeaderMetaInfo"));

var _TopicHeaderLabel = _interopRequireDefault(require("./TopicHeaderLabel"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicHeader, _Component);

  var _super = _createSuper(TopicHeader);

  function TopicHeader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TopicHeader);
    _this = _super.call(this, props);
    _this.showUserLoginModal = _this.showUserLoginModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleVoteClick = _this.handleVoteClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.getIdeationVotesSection = _this.getIdeationVotesSection.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TopicHeader, [{
    key: "showUserLoginModal",
    value: function showUserLoginModal() {
      var ssoLoginUrl = this.props.ssoLoginUrl;

      if (ssoLoginUrl) {
        return;
      }

      window.app.events.commands.execute('modal:login:show');
    }
  }, {
    key: "handleVoteClick",
    value: function handleVoteClick() {
      var _this$props = this.props,
          onVoteClick = _this$props.onVoteClick,
          currentUser = _this$props.currentUser;
      var currentUserId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;

      if (!currentUserId) {
        return this.showUserLoginModal();
      }

      if (onVoteClick) {
        onVoteClick();
      }
    }
  }, {
    key: "getIdeationVotesSection",
    value: function getIdeationVotesSection() {
      var _this2 = this,
          _topic$likedBy;

      var _this$props2 = this.props,
          topic = _this$props2.topic,
          isLiked = _this$props2.isLiked,
          totalLikedUsersCount = _this$props2.totalLikedUsersCount;
      var isIdea = topic.contentType === _contentType.CONTENT_TYPE_IDEA;

      if (!isIdea) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "ideation-view-topic-votes"
      }, (0, _preact.h)("div", {
        className: "ideation-topic-votes-wrapper"
      }, (0, _preact.h)(_TopicVoteCount.TopicVoteButton, {
        hasVoted: isLiked,
        onClick: function onClick() {
          return _this2.handleVoteClick();
        }
      }, (0, _preact.h)(_TopicVoteCount.VoteTriangleIcon, null), (0, _preact.h)(_TopicVoteCount.VoteCountInner, {
        showText: true,
        count: totalLikedUsersCount
      })), (topic === null || topic === void 0 ? void 0 : (_topic$likedBy = topic.likedBy) === null || _topic$likedBy === void 0 ? void 0 : _topic$likedBy.length) > 0 && (0, _preact.h)(_VotedUsers.default, {
        votedBy: topic.likedBy,
        topVotedUsers: topic === null || topic === void 0 ? void 0 : topic.topLikedBy,
        previewCount: 3
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          topic = _this$props3.topic,
          isTranslationInProgress = _this$props3.isTranslationInProgress,
          translatedTitle = _this$props3.translatedTitle,
          totalReplyCount = _this$props3.totalReplyCount;
      return (0, _preact.h)("header", {
        className: "topic__header qa-topic-header",
        id: "firstpost-title"
      }, (0, _preact.h)(_TopicHeaderLabel.default, {
        topic: topic
      }), (0, _preact.h)("h1", {
        className: (0, _classnames.default)('h3', 'topic__title', 'qa-thread-title', {
          'topic__title--translation-in-progress': isTranslationInProgress
        }),
        dangerouslySetInnerHTML: {
          __html: translatedTitle
        }
      }), (0, _preact.h)(_TopicHeaderMetaInfo.default, {
        views: topic.views,
        totalReplyCount: totalReplyCount,
        publishedAt: topic.publishedAt,
        productAreas: topic.productAreas,
        lastEditedAt: topic.contentType === 'article' ? topic === null || topic === void 0 ? void 0 : topic.lastEditedAt : undefined
      }), this.getIdeationVotesSection());
    }
  }]);
  return TopicHeader;
}(_preact.Component);

var _default = (0, _OnDemandTranslations.withOnDemandTranslationProps)(TopicHeader, ['isTranslationInProgress', 'translatedTitle']);

exports.default = _default;